import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Paper,
  Button,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  LinearProgress,
  Select,
  MenuItem,
  InputLabel,
  Chip,
  Avatar,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import {
  explorePostData,
  fetchApidata,
  postApidata,
  postApidatawol,
  getDeployment,
  postDeployment,
  invoiceExploreGetData,
  postData,
  resetTrackingData,
  empAttendance,
  Attendance,
  AttendanceProcess,
} from "../../../store/reducers/Formapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  // DataGrid,
  GridToolbarContainer,
  // GridToolbarColumnsButton,
  // GridToolbarFilterButton,
  // GridToolbarExport,
  // GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";

import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { DataGrid } from "@mui/x-data-grid";
import { useProSidebar } from "react-pro-sidebar";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";

import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import store from "../../../index";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AttendanceHistoryPDF from "../../reports/AttendanceHistoryPdf";
import AttendanceHistoryExcel from "../../reports/AttendanceHistoryExcel";
import { toast } from "react-hot-toast";
import { Employeeautocomplete } from "../../../ui-components/global/Autocomplete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { getConfig } from "../../../config";

import { FaFileExcel } from "react-icons/fa";
import AttenHistrySummatyPDF from "../../reports/AttenHistrySummatyPDF";
import AttendanceHistrySummaryExcel from "../../reports/AttendanceHistrySummaryExcel";

const EditAttendanceHistory = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const mode = params.Mode;
  const dispatch = useDispatch();
  const isManager = sessionStorage.getItem("isManager");
  // const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  var recID = params.id;
  var accessID = params.accessID;
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const listViewData = useSelector((state) => state.listviewApi.rowData);
  const listViewColumn = useSelector((state) => state.listviewApi.columnData);
  // const empAttendanceData = useSelector(
  //   (state) => state.formApi.empAttendanceData
  // );
  // console.log("empAttendanceData", empAttendanceData);

  // const AttendanceData = useSelector((state) => state.formApi.AttendanceData);
  // console.log("AttendanceData", AttendanceData);
  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");

  const config = getConfig();
  const baseurl1 = config.UAAM_URL;
  console.log("HeaderImg", HeaderImg, FooterImg);

  const AttendanceData = useSelector(
    (state) => state.formApi.empAttendanceData
  );
  console.log("AttendanceData", AttendanceData);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const data = useSelector((state) => state.formApi.Data);
  const isLoading = useSelector((state) => state.formApi.loading);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = React.useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [footerHeight, setFooterHeight] = useState(60);
  const [isReady, setIsReady] = useState(false);
  const [show, setScreen] = useState("0");
  const EMPID = sessionStorage.getItem("EmpId");

  const CompanyID = sessionStorage.getItem("companyId");
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [summarycheck, setSummaryCheck] = useState(false);


  const colors = tokens(theme.palette.mode);
  const [errorMsgData, setErrorMsgData] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  useEffect(() => {
    if (!FooterImg) return;

    const url = `${baseurl1}/uploads/images/${FooterImg}`;

    const img = new Image();
    img.src = url;

    img.onload = () => {
      const aspectRatio = img.height / img.width;

      const pageWidth = 842;
      const MAX_FOOTER_HEIGHT = 80; // 🔥 IMPORTANT

      const calculatedHeight = Math.min(
        pageWidth * aspectRatio,
        MAX_FOOTER_HEIGHT
      );

      setFooterHeight(calculatedHeight);
      setIsReady(true);
    };
  }, [FooterImg]);
  function AttendanceTool() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>Attendance</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  const AttColumn = [
    // { field: "SLNO", headerName: "SL#",width:5 },
    //  {
    //   field: "slno",
    //   headerName: "SL#",
    //   width: 50,
    //   sortable: false,
    //   filterable: false,
    //   valueGetter: (params) =>
    //     `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`
    // },
    {
      field: "slno",
      headerName: "SL#",
      width: 40,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "right",
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    { field: "Name", headerName: "Personnel", headerAlign: "center", width: 150 },
    { field: "Designation", headerName: "Designation", headerAlign: "center", width: 150 },
    { field: "Day1", headerName: "1", headerAlign: "center", width: 5 },
    { field: "Day2", headerName: "2", headerAlign: "center", width: 5 },
    { field: "Day3", headerName: "3", headerAlign: "center", width: 5 },
    { field: "Day4", headerName: "4", headerAlign: "center", width: 5 },
    { field: "Day5", headerName: "5", headerAlign: "center", width: 5 },
    { field: "Day6", headerName: "6", headerAlign: "center", width: 5 },
    { field: "Day7", headerName: "7", headerAlign: "center", width: 5 },
    { field: "Day8", headerName: "8", headerAlign: "center", width: 5 },
    { field: "Day9", headerName: "9", headerAlign: "center", width: 5 },
    { field: "Day10", headerName: "10", headerAlign: "center", width: 5 },
    { field: "Day11", headerName: "11", headerAlign: "center", width: 5 },
    { field: "Day12", headerName: "12", headerAlign: "center", width: 5 },
    { field: "Day13", headerName: "13", headerAlign: "center", width: 5 },
    { field: "Day14", headerName: "14", headerAlign: "center", width: 5 },
    { field: "Day15", headerName: "15", headerAlign: "center", width: 5 },
    { field: "Day16", headerName: "16", headerAlign: "center", width: 5 },
    { field: "Day17", headerName: "17", headerAlign: "center", width: 5 },
    { field: "Day18", headerName: "18", headerAlign: "center", width: 5 },
    { field: "Day19", headerName: "19", headerAlign: "center", width: 5 },
    { field: "Day20", headerName: "20", headerAlign: "center", width: 5 },
    { field: "Day21", headerName: "21", headerAlign: "center", width: 5 },
    { field: "Day22", headerName: "22", headerAlign: "center", width: 5 },
    { field: "Day23", headerName: "23", headerAlign: "center", width: 5 },
    { field: "Day24", headerName: "24", headerAlign: "center", width: 5 },
    { field: "Day25", headerName: "25", headerAlign: "center", width: 5 },
    { field: "Day26", headerName: "26", headerAlign: "center", width: 5 },
    { field: "Day27", headerName: "27", headerAlign: "center", width: 5 },
    { field: "Day28", headerName: "28", headerAlign: "center", width: 5 },
    { field: "Day29", headerName: "29", headerAlign: "center", width: 5 },
    { field: "Day30", headerName: "30", headerAlign: "center", width: 5 },
    { field: "Day31", headerName: "31", headerAlign: "center", width: 5 },
    { field: "Present", headerName: "Present", headerAlign: "center", align: "right" },
    // { field: "Leave", headerName: "LEAVE" },
    { field: "UnPaidLeave", headerName: "Unscheduled Leave", headerAlign: "center", align: "right",width: 130 },
    { field: "PaidLeave", headerName: "Scheduled Leave", headerAlign: "center", align: "right",width: 100 },
    // { field: "IRREGULAR", headerName: "IRREGULAR" },
    { field: "Holidays", headerName: "Holidays", headerAlign: "center", align: "right" },
    { field: "Weekoff", headerName: "Week Off", headerAlign: "center", align: "right" },
    { field: "Total", headerName: "Total Days", headerAlign: "center", align: "right" },
  ];

  

  function SummaryTool() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>Summary</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }


  const SummaryColumn = [
    {
      field: "slno",
      headerName: "SL#",
      width: 40,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "right",
      disableColumnMenu: true,
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);

        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();

        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },
    { field: "Name", headerName: "Personnel", width: 300 },
   
    { field: "Present", headerName: "Present", headerAlign: "center", align: "right", },
    // { field: "Leave", headerName: "LEAVE" },
    { field: "UnPaidLeave", headerName: "Unscheduled Leave", headerAlign: "center", align: "right", width: 200 },
    { field: "PaidLeave", headerName: "Scheduled Leave", headerAlign: "center", align: "right", width: 100 },
    // { field: "Irregular", headerName: "IRREGULAR" },
    { field: "Holidays", headerName: "Holidays", headerAlign: "center", align: "right", },
    { field: "Weekoff", headerName: "Week Off", headerAlign: "center", align: "right", },
    { field: "Total", headerName: "Total Days", headerAlign: "center", align: "right", },
  ];

  /***********Attendance ************/

  const currentMonthNumber = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();
  const AttInitialvalues = {
    // code: data.Code,
    // description: data.Name,
    // Sal: data.Sal,
    month: currentMonthNumber,
    year: currentYear,
  };
  const attendaceFnSave = async (values) => {
    const data = {
      Month: values.month.toString(),
      Year: values.year,
      ManagerID: EMPID,
      EmployeeID: EMPID,
      Etype: "E",
      CompanyID
    };

    dispatch(empAttendance({ data }));
    setPage(0);
  };

  const attendaceProcessFnSave = async (values) => {
    // toast.success("----response.payload.Msg");

    console.log("month", values.month.toString());

    const data = {
      Month: values.month.toString(),
      Year: values.year,
      EmployeeID: recID,
    };

    const response = await dispatch(AttendanceProcess({ data }));
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
      navigate("/Apps/TR217/EditAttendance");
    } else {
      toast.error(response.payload.Msg);
    }
  };

  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData
  );
  const explorelistViewColumn = useSelector(
    (state) => state.exploreApi.explorecolumnData
  );
  const empAttLoading = useSelector((state) => state.formApi.empAttendanceDataLoading);
  const screenChange = (event) => {
    setScreen(event.target.value);
  };
  const VISIBLE_FIELDS = [
    "SLNO",
    "OtDate",
    "NumberOfHours",
    "Status",
    "action",
  ];
  const [funMode, setFunMode] = useState("A");
  const columns = React.useMemo(
    () =>
      explorelistViewColumn
        ? explorelistViewColumn.filter((column) =>
          VISIBLE_FIELDS.includes(column.field)
        )
        : [],
    [explorelistViewColumn]
  );

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate("/Apps/Chart");
      }
    });
  };
  const [empData, setempData] = useState(null);
  const handleSelectionEmployeeChange = (newValue) => {
    if (newValue) {
      setempData(newValue);
      console.log(newValue.RecordID, "--selectedproductid");
    } else {
      setempData(null);
    }
  };
  return (
    <React.Fragment>
      {/* {getLoading && <LinearProgress />} */}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}>
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography variant="h3" sx={{ marginLeft: "10px", fontSize: "19px", color:"#0000D1"}}>Attendance Register</Typography>
          </Box>
          <Box display="flex">
            {/* <Tooltip title="Attendance ">
            <IconButton
              onClick={() => navigate("/Apps/TR217/Attendance")}
              color="primary"
            >
              <ListAltOutlinedIcon />
            </IconButton>
          </Tooltip> */}
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      <Paper elevation={3} sx={{ margin: "10px" }}>
        {/* <Box m="10px"> */}
        <Formik
          initialValues={AttInitialvalues}
          enableReinitialize={true}
          onSubmit={(values, { resetForm }) => {
            setTimeout(() => {
              attendaceFnSave(values, resetForm);
            }, 100);
          }}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            resetForm,
          }) => (
            <form
              onSubmit={handleSubmit}
              onReset={() => {
                resetForm();
                dispatch(resetTrackingData());
                setSummaryCheck(false);
              }}
            >
              <Box
                display="grid"
                gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                // gap="70px"
                gap={formGap}
                padding={1}
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 4",
                  },
                }}
              >
                <Stack direction="row" spacing={2}>
                  <TextField
                    fullWidth
                    variant="standard"
                    type="text"
                    id="month"
                    name="month"
                    label="Month"
                    value={values.month}
                    focused
                    onChange={handleChange}
                    onBlur={handleBlur}
                    select
                    sx={{
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent", // optional: adjust if needed
                      },
                      width: 200,
                    }}
                  >
                    <MenuItem value={"1"}>January</MenuItem>
                    <MenuItem value={"2"}>February</MenuItem>
                    <MenuItem value={"3"}>March</MenuItem>
                    <MenuItem value={"4"}>April</MenuItem>
                    <MenuItem value={"5"}>May</MenuItem>
                    <MenuItem value={"6"}>June</MenuItem>
                    <MenuItem value={"7"}>July</MenuItem>
                    <MenuItem value={"8"}>August</MenuItem>
                    <MenuItem value={"9"}>September</MenuItem>
                    <MenuItem value={"10"}>October</MenuItem>
                    <MenuItem value={"11"}>November</MenuItem>
                    <MenuItem value={"12"}>December</MenuItem>
                  </TextField>

                  <TextField
                    fullWidth
                    variant="standard"
                    type="number"
                    id="year"
                    name="year"
                    label="Year"
                    value={values.year}
                    inputProps={{ min: "1900", max: "2100", step: "1" }}
                    focused
                    onChange={handleChange}
                    onBlur={handleBlur}
                    sx={{
                      "& .MuiFilledInput-root": {
                        backgroundColor: "transparent",
                        // optional
                      },
                      width: 200,
                    }}
                  />
                  {/* <Employeeautocomplete
                    sx={{width:400}}
                        name="Employee"
                        label="Employee"
                        id="Employee"
                        value={empData}
                        onChange={handleSelectionEmployeeChange}
                        url={`https://ess.beyondexs.com/api/wslistview_mysql.php?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
                      /> */}
                </Stack>
                <Stack
                  direction="row"
                  spacing={2}
                  display="flex"
                  padding={1}
                  justifyContent="end"
                >

                   <FormControlLabel
                  control={
                    <Checkbox
                    checked={summarycheck}
                    onChange={(e) => setSummaryCheck(e.target.checked)}
                      // checked={attuseCurrentEmp}
                      // onChange={(e) => {
                      //   const checked = e.target.checked;
                      //   setattUseCurrentEmp(checked);
                      //   setattempData(null);
                      //   // sessionStorage.setItem("attuseCurrentEmp", checked);

                      // }}
                      color="primary"
                    />
                  }
                  label="Summary"
                />
                  <Button type="submit" variant="contained" color="secondary">
                    APPLY
                  </Button>
                  {/* <Button
                    onClick={() => attendaceProcessFnSave(values)}
                    type="reset"
                    variant="contained"
                    color="primary"
                  >
                    PROCESS
                  </Button> */}
                  <Button
                    type="reset"
                    variant="contained"
                    color="error"
                    size="small"
                  >
                    RESET
                  </Button>
                  {!summarycheck && isManager === "1" && AttendanceData?.length > 0 && (
                    <PDFDownloadLink
                      document={
                        <AttendanceHistoryPDF
                          data={AttendanceData}
                          filters={{
                            Month: values.month,
                            Year: values.year,
                            EmployeeID: empData?.RecordID,
                            Imageurl: baseurl1,
                            HeaderImg: HeaderImg,
                            FooterImg: FooterImg,

                          }}
                          footerHeight={footerHeight}
                        />
                      }
                      fileName={`Attendance_Report_${empData?.Name || "Employee"
                        }.pdf`}
                      style={{ color: "#d32f2f", cursor: "pointer" }}
                    // onClick={() => setButtonVisible(false)}
                    >
                      {/* {({ loading }) =>
                          loading ? "Preparing document..." : "Download Attendance PDF"                       
                        } */}
                      {({ loading }) =>
                        loading ? (
                          <PictureAsPdfIcon
                            sx={{ fontSize: 24, opacity: 0.5 }}
                          />
                        ) : (
                          <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                        )
                      }
                    </PDFDownloadLink>
                  )}
                  {!summarycheck && isManager === "1" && AttendanceData?.length > 0 && (
                    <FaFileExcel
                      size={20}
                      color="#1D6F42"
                      style={{ cursor: "pointer", }}
                      onClick={() =>
                        AttendanceHistoryExcel(
                          AttendanceData,
                          { month: values.month, year: values.year },
                          empData
                        )
                      }
                    />
                  )}

                    {summarycheck && isManager === "1" && AttendanceData?.length > 0 && (
                    <PDFDownloadLink
                      document={
                        <AttenHistrySummatyPDF
                          data={AttendanceData}
                          filters={{
                            Month: values.month,
                            Year: values.year,
                            EmployeeID: empData?.RecordID,
                            Imageurl: baseurl1,
                            HeaderImg: HeaderImg,
                            FooterImg: FooterImg,

                          }}
                          footerHeight={footerHeight}
                        />
                      }
                      fileName={`Attendance_Report_${empData?.Name || "Employee"
                        }.pdf`}
                      style={{ color: "#d32f2f", cursor: "pointer" }}
                    // onClick={() => setButtonVisible(false)}
                    >
                      {/* {({ loading }) =>
                          loading ? "Preparing document..." : "Download Attendance PDF"                       
                        } */}
                      {({ loading }) =>
                        loading ? (
                          <PictureAsPdfIcon
                            sx={{ fontSize: 24, opacity: 0.5 }}
                          />
                        ) : (
                          <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                        )
                      }
                    </PDFDownloadLink>
                  )}
                  {summarycheck && isManager === "1" && AttendanceData?.length > 0 && (
                    <FaFileExcel
                      size={20}
                      color="#1D6F42"
                      style={{ cursor: "pointer", }}
                      onClick={() =>
                        AttendanceHistrySummaryExcel(
                          AttendanceData,
                          { month: values.month, year: values.year },
                          empData
                        )
                      }
                    />
                  )}


                </Stack>
              </Box>
              {/* <Box display="flex" padding={1} justifyContent="end" mt="10px" gap="20px">
                  <Button type="submit" variant="contained" color="secondary">
                    APPLY
                  </Button>
                  {/* <Button
                    onClick={() => attendaceProcessFnSave(values)}
                    type="reset"
                    variant="contained"
                    color="primary"
                  >
                    PROCESS
                  </Button> *
                  <Button type="reset" variant="contained" color="error">
                    RESET
                  </Button>
                  {isManager === "1" && AttendanceData?.length > 0 && (
  <PDFDownloadLink
    document={
      <AttendanceHistoryPDF
        data={AttendanceData}
        filters={{
          Month: values.month,
          Year: values.year,
          EmployeeID: empData?.RecordID,
        }}
      />
    }
    fileName={`Attendance_Report_${empData?.Name || "Employee"}.pdf`}
    style={{
      textDecoration: "none",
      padding: "6px 12px",
      color: "#fff",
      backgroundColor: "#1976d2",
      borderRadius: 4,
    }}
    // onClick={() => setButtonVisible(false)}
  >
    {({ loading }) =>
      loading ? "Preparing document..." : "Download Attendance PDF"
  
    }
  </PDFDownloadLink>
)}
                </Box> */}
{!summarycheck && (
              <Box sx={{ gridColumn: "span 4" }}>
                <Box
                  height="400px"
                   padding={1}
                  // height={dataGridHeight}
                  marginTop={2}
                  sx={{
                    "& .MuiDataGrid-root": {
                      // border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      // borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      // borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      // borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#d0edec",
                      color: "", // Color for even rows
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={AttendanceData}
                    columns={AttColumn}
                    disableSelectionOnClick
                    getRowId={(row) => row.SLNO}
                    pageSize={pageSize}
                    page={page}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                    onCellClick={(params) => { }}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    components={{
                      Toolbar: AttendanceTool,
                    }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    loading={empAttLoading}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                  />
                </Box>
              </Box>
)}

   <Box sx={{ gridColumn: "span 4" }}>
                <Box
                  height="400px"
                   padding={1}
                  // height={dataGridHeight}
                  marginTop={2}
                  sx={{
                    "& .MuiDataGrid-root": {
                      // border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      // borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[800],
                      // borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      // borderTop: "none",
                      backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                      color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .odd-row": {
                      backgroundColor: "",
                      color: "", // Color for odd rows
                    },
                    "& .even-row": {
                      backgroundColor: "#d0edec",
                      color: "", // Color for even rows
                    },
                  }}
                >
                  <DataGrid
                    sx={{
                      "& .MuiDataGrid-footerContainer": {
                        height: dataGridHeaderFooterHeight,
                        minHeight: dataGridHeaderFooterHeight,
                      },
                    }}
                    rowHeight={dataGridRowHeight}
                    headerHeight={dataGridHeaderFooterHeight}
                    rows={AttendanceData}
                    columns={SummaryColumn}
                    disableSelectionOnClick
                    getRowId={(row) => row.SLNO}
                    pageSize={pageSize}
                    page={page}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    onPageChange={(newPage) => setPage(newPage)}
                    onCellClick={(params) => { }}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    components={{
                      Toolbar: SummaryTool,
                    }}
                    onStateChange={(stateParams) =>
                      setRowCount(stateParams.pagination.rowCount)
                    }
                    loading={empAttLoading}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "odd-row"
                        : "even-row"
                    }
                  />
                </Box>
              </Box>


              <Stack
                direction="row"
                padding={1}
                alignItems="center"
                justifyContent="space-between"

              >
                {/* LEFT SIDE ITEMS */}
                <Box display="flex" alignItems="center" gap={2} >
                  <Chip
                    avatar={<Avatar sx={{ bgcolor: "#ffff", width: 24, height: 24, fontSize: 12 }}>P</Avatar>}
                    label="Present"
                    variant="outlined"
                    sx={{ backgroundColor: "#ccc4c4", }}
                  />


                  <Chip
                    avatar={<Avatar sx={{ bgcolor: "#ffff", width: 24, height: 24, fontSize: 12 }}>WO</Avatar>}
                    label="Week Off"
                    variant="outlined"
                    sx={{ backgroundColor: "#ccc4c4", }}
                  />

                  <Chip
                    avatar={<Avatar sx={{ bgcolor: "#ffff", width: 24, height: 24, fontSize: 12 }}>HO</Avatar>}
                    label="Holiday"
                    variant="outlined"
                    sx={{ backgroundColor: "#ccc4c4", }}
                  />
                  <Chip
                    avatar={<Avatar sx={{ bgcolor: "#ffff", width: 24, height: 24, fontSize: 12 }}>SH</Avatar>}
                    label="Second Half"
                    variant="outlined"
                    sx={{ backgroundColor: "#ccc4c4", }}
                  />
                  <Chip
                    avatar={<Avatar sx={{ bgcolor: "#ffff", width: 24, height: 24, fontSize: 12 }}>CL</Avatar>}
                    label="Casual Leave"
                    variant="outlined"
                    sx={{ backgroundColor: "#ccc4c4", }}
                  />
                  <Chip
                    avatar={<Avatar sx={{ bgcolor: "#ffff", width: 24, height: 24, fontSize: 12 }}>M</Avatar>}
                    label="Medical Leave"
                    variant="outlined"
                    sx={{ backgroundColor: "#ccc4c4", }}
                  />
                  <Chip
                    avatar={<Avatar sx={{ bgcolor: "#ffff", width: 24, height: 24, fontSize: 12 }}>UL</Avatar>}
                    label="Unscheduled Leave"
                    variant="outlined"
                    sx={{ backgroundColor: "#ccc4c4", }}
                  />
                  <Chip
                    avatar={<Avatar sx={{ bgcolor: "#ffff", width: 24, height: 24, fontSize: 12 }}>IR</Avatar>}
                    label="IR Regular"
                    variant="outlined"
                    sx={{ backgroundColor: "#ccc4c4", }}
                  />

                </Box>
              </Stack>
            </form>
          )}
        </Formik>
        {/* </Box> */}
      </Paper>
    </React.Fragment>
  );
};

export default EditAttendanceHistory;
